import React from "react";
import loadable from "@loadable/component";
import CreateIcon from "../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import OverViewIcon from "../Icons/OverViewIcon";
const TemplateListComponent = loadable(
  () => import("../components/Temaplate/TemaplateList")
);
const TemplateList = () => {
  return (
    <>
      <div
            className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
          >
            <OverViewIcon />
            <span className={tw`text-[#5E5757] font-bold text-xl`}>
              Templates
            </span>
          </div>
      <TemplateListComponent />
    </>
  );
};

export default TemplateList;
